import styled from "styled-components";

const TrailerStyles = styled.div`
  padding: 0 20vw;

  @media (max-width: 1608px) {
    padding: 0 15vw;
  }

  @media (max-width: 1378px) {
    padding: 0 10vw;
  }

  @media (max-width: 650px) {
    padding: 0 5vw;
  }

  .player-wrapper {
    position: relative;
    padding-top: 56.25%;
  }

  .react-player {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export default TrailerStyles;



// WEBPACK FOOTER //
// ./src/components/universal-styles/TrailerStyles.js